import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";

import Header from "../components/Header";
import "./index.css";

class TemplateWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      audioIsPlaying: false,
      audioHasBeenTurnedOff: false,
      audioHasBeenStarted: false
    };
  }

  componentDidMount() {
    document.getElementById("backgroundMusic").onplay = () => {
      this.setState({ audioIsPlaying: true, audioHasBeenStarted: true });
    };
  }

  toggleAudio = () => {
    if (this.state.audioHasBeenStarted) {
      this.state.audioIsPlaying ? this.pauseAudio() : this.playAudio();
      this.setState({ audioIsPlaying: !this.state.audioIsPlaying });
    }
  };

  playAudio = turnOn => {
    if (this.state.audioHasBeenTurnedOff) {
      if (turnOn) {
        document.getElementById("backgroundMusic").play();
        this.setState({ audioIsPlaying: true, audioHasBeenTurnedOff: false });
      }
      return;
    }
    document.getElementById("backgroundMusic").play();
  };

  pauseAudio = turnOff => {
    if (turnOff) {
      this.setState({ audioIsPlaying: false, audioHasBeenTurnedOff: true });
    }
    document.getElementById("backgroundMusic").pause();
  };

  render() {
    return (
      <div>
        <Helmet
          title="Thomas Carty"
          meta={[
            { name: "description", content: "Thomas Carty meta description" },
            { name: "keywords", content: "Thomas Carty" }
          ]}
        />
        <Header
          onToggleAudio={this.toggleAudio}
          onPauseAudio={this.pauseAudio}
          onPlayAudio={this.playAudio}
          audioIsPlaying={this.state.audioIsPlaying}
        />
        <main className={"main"}>
          {this.props.children(
            Object.assign({}, this.props, {
              toggleAudio: this.toggleAudio,
              pauseAudio: this.pauseAudio
            })
          )}
        </main>

        <audio id="backgroundMusic" autoPlay loop>
          <source src="/audio/tc-background.mp3" />
          <source src="/audio/tc-background.ogg" />
        </audio>
      </div>
    );
  }
}

TemplateWrapper.propTypes = {
  children: PropTypes.func
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js